// Utilities
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.triggerLogic;

/**
 * Updates the trigger logic.
 *
 * @param {String} triggerLogic The item ID
 * @throws Will throw an error if the item ID is not defined
 * @return {Promise} The apiFetch promise
 */
const setTriggerLogic = ( triggerLogic ) => {
	// If the item is not define, stop here
	if ( isEmpty( triggerLogic ) ) {
		throw new Error( `setTriggerLogic: The trigger logic can't be empty` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'triggers_change_logic',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			trigger_logic: triggerLogic
		},
		snackbar: {
			loading: strings.updatingTriggerLogic,
			success: strings.triggerLogicUpdated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/set-trigger-logic', {
				detail: {
					triggerLogic: triggerLogic
				}
			} ) );
		}

		return response;
	} );
}

export default setTriggerLogic;
